import { getWidgetConfig, isEmbedded } from '@/config'

export const CONTACT_ID_KEY = 'aiq_contact_id'
export const IDENTITY_CONTACT_EVENT = 'identity:contact'

function isDemoMode(): boolean {
  try {
    return isEmbedded()
      ? (getWidgetConfig()?.demo ?? false)
      : new URLSearchParams(window.location.search).get('demo') === 'true'
  } catch {
    return false
  }
}

export function getSharedContactId(): string {
  if (typeof window === 'undefined' || isDemoMode()) return ''
  try {
    return localStorage.getItem(CONTACT_ID_KEY)?.trim() || ''
  } catch {
    return ''
  }
}

/** Persist (or clear) the shared flat contact key used by pixel + widget. */
export function persistSharedContactId(contactID: string | null | undefined): void {
  if (typeof window === 'undefined' || isDemoMode()) return
  try {
    const next = typeof contactID === 'string' ? contactID.trim() : ''
    if (next) {
      localStorage.setItem(CONTACT_ID_KEY, next)
    } else {
      localStorage.removeItem(CONTACT_ID_KEY)
    }
  } catch {
    // ignore quota / private mode
  }
}
